import { X } from "lucide-react";
import rightmark from "../../../../assets/right-mark-with-background.png";

const rightMarkeImg = "check";

const plans = [
  { name: "base",         price: "$18",  accentColor: "#D1BCFF" },
  { name: "premium",      price: "$80",  accentColor: "#FFB599" },
  { name: "premium plus", price: "$230", accentColor: "#FACC15" },
  { name: "ultimate",     price: "$400", accentColor: "#34D399" },
];

const freeBusinessFeatures = [
  { name: "business chat - open customer engagement",              values: ["check","check","check","check"] },
  { name: "in-chat ordering (continuous ordering - pay anytime)", values: ["check","check","check","check"] },
  { name: "in-chat cancellations and refunds",                    values: ["check","check","check","check"] },
  { name: "order capacity and q management",                      values: ["check","check","check","check"] },
  { name: "customisable ordering flows",                          values: ["check","check","check","check"] },
  { name: "hybrid ordering - team members and customers",         values: ["check","check","check","check"] },
  { name: "click and collect",                                    values: ["check","check","check","check"] },
  { name: "customer chat prioritisation",                         values: ["check","check","check","check"] },
  { name: "physical/static & mobile locations",                   values: ["check","check","check","check"] },
  { name: "multi location management",                            values: ["check","check","check","check"] },
  { name: "ratings and reviews",                                  values: ["check","check","check","check"] },
];

const freeAIFeature = [
  { name: "in-chat ai customer support",                          values: ["1k msgs","40k msgs","100k msgs","200k msgs"] },
  { name: "ai order recommendations",                             values: ["check","check","check","check"] },
  { name: "ai order management/placing including customisation",  values: ["check","check","check","check"] },
  { name: "ai booking & reservations",                            values: ["coming soon","coming soon","coming soon","coming soon"] },
];

const freePaymentSolutions = [
  { name: "business wallet per location",  values: ["check","check","check","check"] },
  { name: "manuel or in app payments",     values: ["check","check","check","check"] },
  { name: "digital invoices and receipts", values: ["check","check","check","check"] },
  { name: "upfront payments requests",     values: ["check","check","check","check"] },
  { name: "payment now requests",          values: ["check","check","check","check"] },
  { name: "group ordering and payments",   values: ["check","check","check","check"] },
  { name: "bill and invoice splitting",    values: ["check","check","check","check"] },
  { name: "customer payment history",      values: ["check","check","check","check"] },
  { name: "in-app tipping",               values: ["check","check","check","check"] },
];

const geoMarketingSolutions = [
  { name: "digital storefront per location",                    values: ["1","3","6","10"] },
  { name: "full market place access",                           values: ["check","check","check","check"] },
  { name: "digital menus & digital catalogues",                 values: ["2","10","20","40"] },
  { name: "team association and visibility",                    values: ["5","60","150","200"] },
  { name: "social media, posting (per month)",                  values: ["10","100","300","500"] },
  { name: "likes, following and sharing",                       values: ["check","check","check","check"] },
  { name: "group chats",                                        values: ["check","check","check","check"] },
  { name: "events (per month)",                                 values: ["5","25","60","150"] },
  { name: "fast marketing via posts and text (additional fee)", values: ["check","check","check","check"] },
  { name: "marketing and engagement insights",                  values: ["check","check","check","check"] },
];

const freeInventSolutions = [
  { name: "menu's and catalogues per location, timed", values: ["check","check","check","check"] },
  { name: "item inventory per location",               values: ["check","check","check","check"] },
  { name: "item scanner",                              values: ["check","check","check","check"] },
  { name: "inventory dashboard",                       values: ["check","check","check","check"] },
];

const sections = [
  { title: "free business features",   data: freeBusinessFeatures },
  { title: "free ai features",         data: freeAIFeature },
  { title: "free payment solutions",   data: freePaymentSolutions },
  { title: "geo marketing solutions",  data: geoMarketingSolutions },
  { title: "free inventory solutions", data: freeInventSolutions },
];

const cardStyle = {
  backgroundColor: "rgba(26,26,26,0.8)",
  border: "1px solid rgba(112,0,255,0.2)",
  borderRadius: "32px",
  backdropFilter: "blur(12px)",
  WebkitBackdropFilter: "blur(12px)",
  overflow: "hidden",
};

const CheckIcon = ({ color = "#D1BCFF" }) => (
  <svg width="16" height="16" viewBox="0 0 20 20" fill="none" style={{ flexShrink: 0, margin: "0 auto" }}>
    <circle cx="10" cy="10" r="10" fill={color} />
    <path d="M6 10.5l2.5 2.5 5.5-5.5" stroke="#1A0A2E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const PricingNavContentPageCompare = () => (
  <div className="w-full" style={{ backgroundColor: "#020013" }}>
    <div className="w-full px-4 md:px-12 lg:px-20 xl:px-28 py-16">

      {/* Horizontal scroll wrapper for mobile */}
      <div className="overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        <div style={{ minWidth: "700px" }}>

          {/* Plan header row */}
          <div className="grid mb-12" style={{ gridTemplateColumns: "2fr 1fr 1fr 1fr 1fr" }}>
            <div />
            {plans.map((plan) => (
              <div key={plan.name} className="flex flex-col items-center gap-2">
                <span className="lowercase" style={{ fontFamily: "Inter, sans-serif", fontWeight: 600, fontSize: "13px", letterSpacing: "1px", color: plan.accentColor, whiteSpace: "nowrap" }}>
                  {plan.name}
                </span>
                <span className="flex items-baseline gap-1 whitespace-nowrap">
                  <span style={{ fontFamily: "Inter, sans-serif", fontWeight: 700, fontSize: "clamp(26px, 5.5vw, 40px)", lineHeight: "1", color: "#FFFFFF" }}>{plan.price}</span>
                  <span style={{ fontFamily: "Inter, sans-serif", fontWeight: 400, fontSize: "12px", color: "rgba(255,255,255,0.4)" }}>/ mo</span>
                </span>
              </div>
            ))}
          </div>

          {/* Feature sections */}
          <div className="flex flex-col" style={{ gap: "60px" }}>
            {sections.map(({ title, data }) => (
              <div key={title}>
                <p
                  className="lowercase mb-5"
                  style={{ fontFamily: "Inter, sans-serif", fontWeight: 500, fontSize: "clamp(18px, 4vw, 24px)", lineHeight: "1.4", color: "#721AF0", paddingLeft: "16px" }}
                >
                  {title}
                </p>

                <div style={cardStyle}>
                  {data.map((item, i) => (
                    <div
                      key={i}
                      className="grid items-center"
                      style={{
                        gridTemplateColumns: "2fr 1fr 1fr 1fr 1fr",
                        minHeight: "64px",
                        paddingLeft: "16px",
                        paddingRight: "16px",
                        borderTop: i >= 0 ? "1px solid #4A445733" : "none",
                      }}
                    >
                      {/* Feature name */}
                      <span
                        className="lowercase pr-3"
                        style={{ fontFamily: "Inter, sans-serif", fontWeight: 400, fontSize: "clamp(14px, 3.5vw, 20px)", lineHeight: "1.4", color: "#FFFFFF" }}
                      >
                        {item.name}
                      </span>

                      {/* Plan values */}
                      {item.values.map((val, j) => (
                        <div key={j} className="flex justify-center items-center">
                          {val === "check" ? (
                            <CheckIcon color={plans[j].accentColor} />
                          ) : val === "✗" || val === "x" ? (
                            <X size={16} style={{ color: "rgba(255,255,255,0.25)" }} />
                          ) : (
                            <span style={{
                              fontFamily: "Inter, sans-serif",
                              fontWeight: 400,
                              fontStyle: val === "coming soon" ? "italic" : "normal",
                              fontSize: "clamp(12px, 3vw, 14px)",
                              lineHeight: "1.4",
                              color: val === "coming soon" ? "#D1BCFF" : "#CCC3DA",
                              textAlign: "center",
                              whiteSpace: "nowrap",
                            }}>
                              {val}
                            </span>
                          )}
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

        </div>
      </div>
    </div>
  </div>
);

export default PricingNavContentPageCompare;
